function showPane(selector) {
    $(selector).addClass("active show");
}

function hidePane(selector) {
    $(selector).removeClass("active show");
}

function handleTabClick(e) {
    e.preventDefault();

    const target = $(e.target).attr("href");
    const $pageMenu = $(e.target).closest(".page-menu");
    const panesSelector = $pageMenu.data("rel") + " > .tab-pane";

    // set active tab
    $pageMenu.find(".nav-link").removeClass("active");
    $(e.target).addClass("active");

    // set active pane
    $(panesSelector).removeClass("show");
    setTimeout(() => {
        if (target.includes("-all")) {
            // show all panes
            showPane(panesSelector);
        } else {
            // show target pane
            hidePane(panesSelector);
            showPane(target);
        }
    }, 150);
}

$(function () {
    $(document).on("click", ".tab-page-menu .nav-link", handleTabClick);
});
